import Vue from 'vue';
import olmap from '../static/sdk/ol-debug.js';
import { sync } from 'vuex-router-sync';
import proj4 from '../static/sdk/proj4.js';
import filter from '@/filter';
import event from '@/utils/event';
import store from '@/store';
import router from '@/router';
import App from './App';
import '@/components';
import '@/config/system/k-config-api';
import axios from 'axios';
import ViewUI from 'view-design';
import '../static/sdk/ol.css';
import './styles/common.css';
import '../static/cssCommon/newmain.css';
import ECharts from '../static/sdk/echarts.min.js';
import vRegion from 'v-region';
import 'view-design/dist/styles/iview.css';
import appConfig from 'appConfig';
import VueBus from 'vue-bus';
import '../static/fxicon/iconfont.css';
import layer from 'vue-layer'; //引入layui弹框
import 'vue-layer/lib/vue-layer.css';
import 'viewerjs/dist/viewer.css';
import * as turf from '@turf/turf';
import VueViewer from 'v-viewer';
import publicMethod from './assets/js/common';
import '../static/sdk/earth/Widgets/widgets.css'; //三维样式
// import '../static/font/PingFang.css';
import VueVideoPlayer from 'vue-video-player';
window.videojs = VueVideoPlayer.videojs;
import 'video.js/dist/video-js.css';



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
require('video.js/dist/lang/zh-CN.js');
Vue.use(VueVideoPlayer);
Vue.use(ElementUI)
Vue.use(vRegion);
Vue.use(event);
Vue.use(ViewUI);
Vue.use(VueBus);
Vue.use(VueViewer);
Vue.prototype.HOST = '/api';
Object.defineProperty(Vue.prototype, '$ECharts', { value: ECharts });
Object.defineProperty(Vue.prototype, '$axios', { value: axios });
Object.defineProperty(Vue.prototype, '$olmap', { value: olmap });
Object.defineProperty(Vue.prototype, 'proj4', { value: proj4 });
Vue.prototype.$layer = layer(Vue);
Vue.prototype.$turf = turf;
Vue.config.devtools = true;
Vue.config.productionTip = false;

//公共方法全局
Vue.prototype.publicMethod = publicMethod;
sync(store, router);

// 全局注册filter
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key]);
});
import { setStore, getStore, removeStore } from '@/utils/storage';
Vue.prototype.setStore = setStore;
Vue.prototype.getStore = getStore;
Vue.prototype.removeStore = removeStore;

const requireAll = (requireContext = {}) => requireContext.keys().map(requireContext);
document.title = appConfig.app.title;

/**
 * @author szc
 * @errorImg 加载失败使用默认图片
 * @date 2023-06-27
 */
const errorImgSrc = require('../static/image/errorData.png');
const loadingImgSrc = require('../static/image/jzz.png');
Vue.directive('errorImg', {
  bind: function(el, binding) {
    let imgSrc = el.src;
    el.src = errorImgSrc;
    el.onload = e => {
      el.src = imgSrc;
      el.onload = null;
    };
    el.onerror = e => {
      el.src = errorImgSrc;
      el.onerror = null;
    };
  },
  update: function(el, binding) {
    // let imgSrc = el.src;
    // console.log("imgSrc", imgSrc)
    // el.src = loadingImgSrc
    // el.onload = (e) => {
    //   el.src = imgSrc
    //   el.onload = null
    // }

    el.onerror = () => {
      el.src = errorImgSrc;
      el.onerror = null;
    };
  },
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js